import React from 'react';
import { Check, Shield, Users, HeartHandshake, Wallet, Award, Clock, Star } from 'lucide-react';
import './About.css';

const About = () => {
  const features = [
    {
      icon: <Shield size={20} />,
      title: 'Certified Physiotherapists',
      desc: 'All our physiotherapists hold BPT/MPT degrees with specialized certifications in orthopedics, neurology, and sports medicine.',
    },
    {
      icon: <Users size={20} />,
      title: 'Expert Medical Team',
      desc: 'Our team includes 20+ experienced physiotherapists, each with 5+ years of hands-on clinical experience in diverse specializations.',
    },
    {
      icon: <HeartHandshake size={20} />,
      title: 'Patient-Centered Care',
      desc: 'We create personalized treatment plans tailored to each patient\'s unique condition, goals, and recovery timeline.',
    },
    {
      icon: <Wallet size={20} />,
      title: 'Affordable Healthcare',
      desc: 'Transparent pricing with no hidden charges. Quality physiotherapy accessible to everyone in Greater Noida and NCR.',
    },
  ];

  const milestones = [
    { icon: <Award size={24} />, value: '12+', label: 'Years of Excellence' },
    { icon: <Users size={24} />, value: '30,000+', label: 'Patients Treated' },
    { icon: <Star size={24} />, value: '4.9/5', label: 'Patient Rating' },
    { icon: <Clock size={24} />, value: '20+', label: 'Expert Physios' },
  ];

  return (
    <div className="about-page">
      <section className="section">
        <div className="about-grid">
          <div className="about-left">
            <img
              className="about-img-main"
              src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&h=500&fit=crop"
              alt="RV Physio Therapy clinic interior in Greater Noida"
            />
            <div className="about-experience">
              <h3>12+</h3>
              <p>Years of Excellence</p>
            </div>
          </div>
          <div className="about-right">
            <h1>About RV Physio Therapy</h1>
            <p>RV Physio Therapy has been Greater Noida's most trusted physiotherapy clinic for over 12 years. We combine evidence-based physiotherapy techniques with modern rehabilitation equipment to deliver exceptional patient outcomes.</p>
            <p style={{marginTop: '12px', color: 'var(--text-light)'}}>Located in Techzone-IV, we serve patients from Greater Noida, Noida, Ghaziabad, and Delhi NCR with specialized treatments for back pain, sports injuries, stroke recovery, and joint rehabilitation.</p>
            <div className="feature-list">
              {features.map((feature, i) => (
                <div className="feature-item" key={i}>
                  <div className="feature-check">{feature.icon}</div>
                  <div>
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Milestones */}
        <div className="milestones-section">
          <div className="milestones-grid">
            {milestones.map((m, i) => (
              <div className="milestone-card" key={i}>
                <div className="milestone-icon">{m.icon}</div>
                <h3>{m.value}</h3>
                <p>{m.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
